export default __webpack_public_path__ + "bd67e86c69a05b1b7643c3b0e39d13e2.png";